document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.jm-drawer, .jm-overlay').forEach(function(el) {
    document.body.appendChild(el);
  });
});

document.addEventListener('click', function(e) {
  // Cerrar con X
  if (e.target.closest('.jm-drawer__close')) {
    const drawer = e.target.closest('.jm-drawer');
    if (!drawer) return;
    const productId = drawer.id.replace('jm-drawer-card-', '');
    drawer.classList.remove('is-open');
    const overlay = document.getElementById('jm-overlay-card-' + productId);
    if (overlay) overlay.classList.remove('is-open');
    return;
  }

  // Cerrar con overlay
  if (e.target.classList.contains('jm-overlay')) {
    const productId = e.target.id.replace('jm-overlay-card-', '');
    e.target.classList.remove('is-open');
    const drawer = document.getElementById('jm-drawer-card-' + productId);
    if (drawer) drawer.classList.remove('is-open');
    return;
  }

  // Abrir drawer
  const trigger = e.target.closest('.jm-stars-trigger');
  if (!trigger) return;
  e.preventDefault();
  e.stopPropagation();

  const drawerId = trigger.dataset.drawerId;
  const productId = drawerId.replace('jm-drawer-card-', '');
  const drawer = document.getElementById(drawerId);
  const overlay = document.getElementById('jm-overlay-card-' + productId);
  if (!drawer || !overlay) return;

  drawer.classList.add('is-open');
  overlay.classList.add('is-open');

  if (window.jdgm) jdgm.customWidgetsLoader.loadAll();
});
